import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
  class: "exercise-container-title flex"
};
var _hoisted_2 = {
  class: "exercise-container-title-left"
};
var _hoisted_3 = {
  class: "exercise-time"
};
var _hoisted_4 = {
  key: 0,
  class: "nested"
};
var _hoisted_5 = ["innerHTML"];
var _hoisted_6 = {
  key: 0,
  class: "exercise-container-options"
};
var _hoisted_7 = {
  class: "multiple-checkbox-view"
};
var _hoisted_8 = {
  class: "code"
};
var _hoisted_9 = {
  class: "label"
};
var _hoisted_10 = ["innerHTML"];
var _hoisted_11 = {
  class: "exercise-container-tags"
};
import { computed } from 'vue';
import { EXERCISE_TYPE_NAME } from '@/const/enum';
import publicProps from './props';
export default {
  __name: 'MultipleChoice',
  props: publicProps,
  setup: function setup(__props) {
    var props = __props;
    var showOptions = computed(function () {
      return props.data.collectionTypeDirect === '0' || props.data.collectionType === 0;
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass({
          'multiple-choice': true,
          'exercise-container': true,
          'is-nested': props.isNested
        })
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [!props.isNested ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass({
          flex: !props.isApp
        })
      }, [_createElementVNode("div", {
        class: _normalizeClass({
          'exercise-type': true,
          'margin-b': props.isApp
        })
      }, _toDisplayString(_unref(EXERCISE_TYPE_NAME)[props.type]), 3), _createElementVNode("div", {
        class: _normalizeClass({
          flex: props.isApp
        })
      }, [_createElementVNode("span", _hoisted_3, _toDisplayString(props.data._createTime), 1), _createElementVNode("span", null, _toDisplayString(props.data.fromWhere), 1)], 2)], 2)) : _createCommentVNode("", true)]), _renderSlot(_ctx.$slots, "handle")]), _createElementVNode("div", {
        class: _normalizeClass({
          'exercise-container-content': true,
          isDetail: props.detail
        })
      }, [props.isNested ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString("".concat(props.index, ".")) + "【" + _toDisplayString(_unref(EXERCISE_TYPE_NAME)[props.type]) + "】", 1)) : _createCommentVNode("", true), _createElementVNode("p", {
        innerHTML: props.data.exercise.content
      }, null, 8, _hoisted_5)], 2), showOptions.value ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("ul", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data.exercise.options, function (item) {
        return _openBlock(), _createElementBlock("li", {
          key: item.sign,
          class: _normalizeClass(['option'])
        }, [_createElementVNode("span", _hoisted_8, _toDisplayString(item.code) + ".", 1), _createElementVNode("p", _hoisted_9, [_createElementVNode("span", {
          class: "text",
          innerHTML: item.content
        }, null, 8, _hoisted_10)])]);
      }), 128))])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_11, [_renderSlot(_ctx.$slots, "tags")]), _renderSlot(_ctx.$slots, "info")], 2);
    };
  }
};